module.exports = __webpack_public_path__ + "img/firefox.da606d49.svg";